'use strict';

angular.module('ClinicApp').directive('truncatedText', function() {
  return {
    templateUrl: '/views/directives/_truncated-text.html',
    transclude: true,
    scope: {
      text: '&',
    },
    link: function(scope, elem, attrs) {
      var limitThreshold = attrs.limitThreshold || 25;
      var maxDisplayLength = attrs.maxDisplayLength;
      scope.isTruncated = false;
      scope.showFullText = false;

      // If there's no text provided, use whatever was in the element.
      if (!attrs.text) {
        var originalText;
        angular.forEach(elem.children(), function(child) {
          if (child.getAttribute('data-ng-transclude') !== null) {
            // Angular puts the transcluded content within
            // an extra .ng-scope span.
            var scopeElement = angular.element(child).children()[0];
            originalText = angular.element(scopeElement).text();
            child.parentNode.removeChild(child);
          }
        });

        setText(originalText);
      } else {
        scope.$watch(scope.text, setText);
      }

      function setText(newText) {
        scope.fullText = newText;
        scope.truncatedText = truncate(newText);
        scope.showFullText = false;
      }

      function truncate(text) {
        scope.isTruncated = false;
        if (maxDisplayLength === null) {
          return text;
        }

        if (text && text.length > maxDisplayLength) {
          var chopped = text.substring(0, maxDisplayLength - 1);
          chopped = chopped.substring(0, chopped.lastIndexOf(' '));

          // If we are within the threshold, return the whole string.
          if (chopped.length >= text.length - limitThreshold) {
            return text;
          } else {
            scope.isTruncated = true;
            chopped += '...';
            return chopped;
          }
        }

        return text;
      }
    },
  };
});
